import { resource } from "./resource";

const api = resource("/holiday");

export const createHolidays = async (input = {}) => await api.post("", input);

export const getAllHolidays = async () => await api.get();
